import { makeApi } from '@zodios/core';
import { z } from 'zod';

const redirectApi = makeApi([
  {
    public: true,
    method: 'get',
    path: '/:shortCode',
    alias: 'redirect',
    description: 'Redirects to the target URL for the given shortCode',
    parameters: [
      {
        name: 'shortCode',
        type: 'Path',
        schema: z.string().length(7),
      },
    ],
    response: z.void(),
    status: 307,
    errors: [
      {
        status: 404,
        description: 'Link not found',
        schema: z.string(),
      },
      {
        status: 500,
        description: 'Internal Server Error',
        schema: z.string(),
      },
    ],
  },
]);

export default redirectApi;